import { Component, ViewChild, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { HisSearchResultComponent, HisNavigationService } from 'hisng';

@Component( {
    selector: 'psv-person-search-result',
    templateUrl: './person-search-result.component.html',
    standalone: false
} )
export class PersonSearchResultComponent implements OnInit {
    private route = inject(ActivatedRoute);
    navigationService = inject(HisNavigationService);


    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;

    public showBackButton = false;

    ngOnInit() {
        this.route.queryParams.subscribe( (queryParams: Params) => {
            this.showBackButton = queryParams['showBackButton'] ? queryParams['showBackButton'] === 'true' : this.showBackButton;
        });
    }
}
